import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Card, Divider, Paper, Fade, Slide, Box, Chip } from '@mui/material';
import ImageViewer from "react-simple-image-viewer";
import { Carousel } from 'react-responsive-carousel';
import axios from 'axios'
// components
import './beranda.css'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useState, useEffect } from 'react';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import LocalDiningOutlinedIcon from '@mui/icons-material/LocalDiningOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useNavigate } from 'react-router-dom';
import YouTubeVideo from '../components/youtube/YoutubeVideo'

// ----------------------------------------------------------------------

const SectionHeader = ({ title, subtitle }) => (
  <Box sx={{ textAlign: 'center', mb: 4 }}>
    <Typography
      variant="h4"
      sx={{
        fontWeight: 800,
        fontSize: { xs: '22px', md: '28px' },
        color: '#1A1A2E',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        letterSpacing: '-0.5px',
        mb: 1,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" sx={{ color: '#6B7280', maxWidth: 480, mx: 'auto' }}>
        {subtitle}
      </Typography>
    )}
    <Box sx={{
      width: 50, height: 3, mt: 1.5, mx: 'auto',
      background: 'linear-gradient(90deg, #B85C2C, #F5A623)',
      borderRadius: 2
    }} />
  </Box>
);

const StatCard = ({ number, label, icon, delay }) => (
  <Slide direction="up" in timeout={delay}>
    <Paper
      elevation={0}
      sx={{
        textAlign: 'center',
        p: 3,
        borderRadius: '20px',
        background: 'rgba(255,255,255,0.15)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.25)',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          background: 'rgba(255,255,255,0.22)',
          boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
        }
      }}
    >
      <Box sx={{ color: 'rgba(255,255,255,0.8)', mb: 1, fontSize: 32 }}>{icon}</Box>
      <Typography sx={{
        fontSize: { xs: '36px', md: '48px' },
        fontWeight: 800,
        color: '#fff',
        lineHeight: 1,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        textShadow: '0 2px 8px rgba(0,0,0,0.2)',
        mb: 0.5,
      }}>
        {number?.toLocaleString('id-ID')}
      </Typography>
      <Typography sx={{
        color: 'rgba(255,255,255,0.85)',
        fontWeight: 600,
        fontSize: '13px',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      }}>
        {label}
      </Typography>
    </Paper>
  </Slide>
);

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const API_URL = process.env.REACT_APP_API
  const BACKEND_API = process.env.REACT_APP_BE
  const [currentImage, setCurrentImage] = useState(0);
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    navigate(`${id}`)
  };

  const images = []
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = async (index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const [beranda, setBeranda] = useState([])
  const getBeranda = async () => {
    try {
      await axios.get(`${API_URL}beranda/allBeranda`)
      .then(({data}) => {
        setBeranda(data?.data)
      })
      .catch((err) => {
        if(err.response.status === 404){ setBeranda([]) }
    })
    } catch (error) {
      console.log(error)
    }
  }

  const [slidePic, setSlidePic] = useState('')
  const [slider, setSlider] = useState([])
  const [supportPic, setSupportPic] = useState('')

  slider?.map((src) =>
      images.push(`${BACKEND_API}${src.link}`)
  )

  const getSlider = async () => {
    try {
      await axios.get(`${API_URL}slider/allSlider`)
      .then(({data}) => {
        setSlider(data?.data)
        setSlidePic(<Carousel
          autoPlay
          infiniteLoop
          dynamicHeight
          fullWidth
          autoFocus
          showThumbs={0}
          showStatus={0}
          interval={4000}
          transitionTime={600}
          >
          {
            data?.data?.map((src, index) => (
              <div key={index} onClick={() => openImageViewer(index)} role='presentation'>
                  <img src={`${BACKEND_API}${src.link}`} style={{
                    borderRadius: '0px',
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover'
                  }} alt='img' className='sliderHeight'/>
              </div>
            ))
          }
        </Carousel>)
      })
      .catch((err) => {
        if(err.response.status === 404){ setSlider([]) }
    })
    } catch (error) {
      console.log(error)
    }
  }

  const getSupport = async () => {
    try {
      await axios.get(`${API_URL}support/allSupport`)
      .then(({data}) => {
        setSupportPic(<Carousel
          autoPlay
          infiniteLoop
          fullWidth
          showThumbs={0}
          showStatus={0}
          >
          {
            data?.data?.map((src, index) => (
              <div key={index}>
                <div onClick={() => {window.open(src.linkSupport)}} style={{cursor: 'pointer', padding: '12px'}} role='presentation'>
                  <img src={`${BACKEND_API}${src.link}`} alt='img' style={{ width: '80px', height: '80px', objectFit: 'contain', borderRadius: '12px' }}/>
                </div>
                <div style={{marginTop: "10px"}}>
                  <Typography variant='subtitle1' sx={{ fontWeight: 600, color: '#1A1A2E' }}>{src.nama}</Typography>
                </div>
                <div style={{marginTop: "12px"}}>
                  <Typography variant='subtitle1'>&nbsp;</Typography>
                </div>
              </div>
            ))
          }
        </Carousel>)
      })
      .catch((err) => {
        if(err.response.status === 404){ setSlider([]) }
    })
    } catch (error) {
      console.log(error)
    }
  }

  const [beritaTerbaru, setBeritaTerbaru] = useState([])
  const getBeritaTerbaru = async () => {
    try {
      await axios.get(`${API_URL}berita/beritaTerbaru`)
      .then(({data}) => {
        setBeritaTerbaru(data?.data)
      })
      .catch((err) => {
        if(err.response.status === 404){ setBeritaTerbaru([]) }
    })
    } catch (error) {
      console.log(error)
    }
  }

  const [kudapanTerbaru, setKudapanTerbaru] = useState([])
  const getKudapanTerbaru = async () => {
    try {
      await axios.get(`${API_URL}join/allKudapan`)
      .then(({data}) => {
        setKudapanTerbaru(data?.data)
      })
      .catch((err) => {
        if(err.response.status === 404){ setKudapanTerbaru([]) }
    })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getBeranda();
    getSlider();
    getSupport();
    getBeritaTerbaru();
    getKudapanTerbaru();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ backgroundColor: '#FDFAF6', minHeight: '100vh' }}>
      <Helmet>
        <title>{localStorage.getItem("judul") !== null ? localStorage.getItem("judul") : ''} | Beranda</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <meta name="description" content="Gastronomi Kuliner Bandung Barat" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>

      {/* ===== HERO SECTION ===== */}
      <Box sx={{
        background: 'linear-gradient(135deg, #1A1A2E 0%, #2C1810 60%, #3D2314 100%)',
        pt: { xs: '80px', md: '94px' },
        pb: 0,
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative background orbs */}
        <Box sx={{
          position: 'absolute', top: '20%', left: '-5%', width: 300, height: 300,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(184,92,44,0.18) 0%, transparent 70%)',
          filter: 'blur(40px)',
          pointerEvents: 'none',
        }} />
        <Box sx={{
          position: 'absolute', top: '10%', right: '-5%', width: 350, height: 350,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(245,166,35,0.12) 0%, transparent 70%)',
          filter: 'blur(50px)',
          pointerEvents: 'none',
        }} />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1, px: { xs: 2, sm: 3, md: 5 } }}>
          <Fade in timeout={800}>
            <Box sx={{ textAlign: 'center', pb: 4, pt: 2 }}>
              <Chip
                label="🍽️ Eksplorasi Gastronomi"
                sx={{
                  background: 'rgba(184, 92, 44, 0.2)',
                  color: '#F5A623',
                  fontWeight: 700,
                  fontSize: '12px',
                  border: '1px solid rgba(245,166,35,0.3)',
                  mb: 2,
                  px: 1,
                }}
              />
              <Typography
                className='text1'
                sx={{
                  mb: 1,
                  px: { xs: 2, md: 0 },
                }}
              >
                {beranda[0]?.judul}
              </Typography>
              <Typography sx={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: { xs: '14px', md: '18px' },
                maxWidth: 560,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                mb: 3,
              }}>
                {beranda[0]?.sub_judul}
              </Typography>
            </Box>
          </Fade>

          {/* Hero Carousel */}
          <Fade in timeout={1200}>
            <Box sx={{
              borderRadius: '20px 20px 0 0',
              overflow: 'hidden',
              boxShadow: '0 -10px 60px rgba(184, 92, 44, 0.2)',
            }}>
              <div className="carousel-wrapper" style={{ borderRadius: 0 }}>
                {slidePic}
              </div>
            </Box>
          </Fade>
        </Container>
      </Box>

      {isViewerOpen && (
        <ImageViewer
          src={images}
          currentIndex={currentImage}
          onClose={closeImageViewer}
          backgroundStyle={{ backgroundColor: "rgba(0,0,0,0.92)" }}
          closeOnClickOutside={1}
        />
      )}

      {/* ===== MAIN CONTENT ===== */}
      <Container maxWidth="xl" sx={{ pt: 6, pb: 4, px: { xs: 2, sm: 3, md: 5 } }}>
        <Grid container spacing={4}>

          {/* ===== DESCRIPTION SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={600}>
              <Card elevation={0} sx={{
                borderRadius: '24px',
                p: { xs: 3, md: 5 },
                background: 'linear-gradient(135deg, #fff8f0 0%, #fff 100%)',
                border: '1px solid rgba(184, 92, 44, 0.10)',
                boxShadow: '0 8px 40px rgba(184, 92, 44, 0.07)',
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Box sx={{
                    width: 40, height: 40, borderRadius: '10px',
                    background: 'linear-gradient(135deg, #B85C2C, #F5A623)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <RestaurantOutlinedIcon sx={{ color: '#fff', fontSize: 22 }} />
                  </Box>
                  <Typography variant="h5" sx={{
                    fontWeight: 800, color: '#1A1A2E',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: { xs: '18px', md: '22px' },
                  }}>
                    {beranda[0]?.judul}
                  </Typography>
                </Box>
                <Typography variant="subtitle1" sx={{
                  color: '#B85C2C', fontWeight: 600, mb: 2, fontSize: '14px',
                  letterSpacing: '0.02em',
                }}>
                  {beranda[0]?.sub_judul}
                </Typography>
                <Divider sx={{ mb: 2.5, borderColor: 'rgba(184, 92, 44, 0.12)' }} />
                <Typography component={'div'} sx={{
                  textAlign: 'justify',
                  color: '#374151',
                  lineHeight: 1.8,
                  fontSize: '15px',
                  '& p': { marginBottom: '12px' },
                  '& strong': { color: '#B85C2C' },
                }}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{ __html: beranda[0]?.content }} />
                </Typography>
              </Card>
            </Slide>
          </Grid>

          {/* ===== RIGHT CONTENT PANEL ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={800}>
              <Card elevation={0} sx={{
                borderRadius: '24px',
                p: { xs: 3, md: 5 },
                background: 'linear-gradient(135deg, #fff 0%, #fff8f0 100%)',
                border: '1px solid rgba(184, 92, 44, 0.10)',
                boxShadow: '0 8px 40px rgba(184, 92, 44, 0.07)',
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                  <Box sx={{
                    width: 40, height: 40, borderRadius: '10px',
                    background: 'linear-gradient(135deg, #2C4A1E, #4A7A30)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <LocalDiningOutlinedIcon sx={{ color: '#fff', fontSize: 22 }} />
                  </Box>
                  <Typography variant="h5" sx={{
                    fontWeight: 800, color: '#1A1A2E',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: { xs: '18px', md: '22px' },
                  }}>
                    Tentang Gastronomi
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2.5, borderColor: 'rgba(184, 92, 44, 0.12)' }} />
                <Typography sx={{
                  textAlign: 'justify',
                  color: '#374151',
                  lineHeight: 1.8,
                  fontSize: '15px',
                  '& p': { marginBottom: '12px' },
                }}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{ __html: beranda[0]?.rightContent }} />
                </Typography>
              </Card>
            </Slide>
          </Grid>

          {/* ===== ABOUT SECTION (Left text + Map) ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={900}>
              <Card elevation={0} sx={{
                borderRadius: '24px',
                p: { xs: 3, md: 4 },
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.06)',
                boxShadow: '0 8px 40px rgba(0,0,0,0.06)',
              }}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <LocationOnOutlinedIcon sx={{ color: '#B85C2C', fontSize: 20 }} />
                      <Typography variant="overline" sx={{ color: '#B85C2C', fontWeight: 700, fontSize: '11px', letterSpacing: '0.1em' }}>
                        Tentang Wilayah
                      </Typography>
                    </Box>
                    <Typography variant="h4" sx={{
                      fontWeight: 800,
                      color: '#1A1A2E',
                      mb: 2,
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontSize: { xs: '22px', md: '28px' },
                    }}>
                      {beranda[0]?.kabupatenkota}
                    </Typography>
                    <Divider sx={{ mb: 2, borderColor: 'rgba(184,92,44,0.12)' }} />
                    <Typography component="div" sx={{
                      color: '#374151', lineHeight: 1.8, fontSize: '15px',
                      '& p': { mb: '10px' },
                    }}>
                      {/* eslint-disable-next-line */}
                      <div dangerouslySetInnerHTML={{ __html: beranda[0]?.leftAbout }} />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{
                      borderRadius: '16px',
                      overflow: 'hidden',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                      border: '1px solid rgba(0,0,0,0.06)',
                    }}>
                      <img
                        src={`${BACKEND_API}${beranda[0]?.image2}`}
                        alt='map'
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                      />
                    </Box>
                    <Typography variant="caption" sx={{
                      display: 'block', textAlign: 'center', mt: 1.5,
                      color: '#6B7280', fontWeight: 500,
                      fontSize: '12px', letterSpacing: '0.03em',
                    }}>
                      Peta {beranda[0]?.kabupatenkota}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Slide>
          </Grid>

          {/* ===== STATS SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={1000}>
              <Box sx={{
                borderRadius: '28px',
                p: { xs: 3, md: 5 },
                background: 'linear-gradient(135deg, #1A1A2E 0%, #B85C2C 50%, #8B3E18 100%)',
                boxShadow: '0 20px 60px rgba(184, 92, 44, 0.3)',
                position: 'relative',
                overflow: 'hidden',
              }}>
                {/* bg pattern */}
                <Box sx={{
                  position: 'absolute', top: '-20%', right: '-5%',
                  width: 300, height: 300, borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(245,166,35,0.15) 0%, transparent 70%)',
                  filter: 'blur(40px)', pointerEvents: 'none',
                }} />
                <SectionHeader
                  title={<span style={{ color: '#fff' }}>Gastronomi dalam Angka</span>}
                />
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <StatCard
                      number={beranda[0]?.rumahMakan}
                      label="Rumah Makan"
                      icon={<RestaurantOutlinedIcon fontSize="inherit" />}
                      delay={1000}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <StatCard
                      number={beranda[0]?.umkm}
                      label="UMKM Kuliner"
                      icon={<StorefrontOutlinedIcon fontSize="inherit" />}
                      delay={1100}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <StatCard
                      number={beranda[0]?.hotel}
                      label="Hotel"
                      icon={<HotelOutlinedIcon fontSize="inherit" />}
                      delay={1200}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Slide>
          </Grid>

          {/* ===== YOUTUBE SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={1100}>
              <Card elevation={0} sx={{
                borderRadius: '24px',
                overflow: 'hidden',
                border: '1px solid rgba(0,0,0,0.06)',
                boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
              }}>
                <YouTubeVideo videoId={beranda[0]?.email} />
              </Card>
            </Slide>
          </Grid>

          {/* ===== MAKANAN KHAS SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={1200}>
              <Box>
                <SectionHeader
                  title="Makanan Khas"
                  subtitle="Jelajahi kuliner autentik yang menjadi kebanggaan Bandung Barat"
                />
                <Grid container spacing={3}>
                  {kudapanTerbaru?.slice(0, 3)?.map((data, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                      <Card
                        className="kudapan"
                        onClick={() => handleCardClick(`/detail/${data?.id}`)}
                        sx={{ position: 'relative', borderRadius: '18px !important' }}
                      >
                        <img
                          src={`${BACKEND_API}${data?.image1}`}
                          alt={data?.nama_makanan}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                            transition: 'transform 0.5s ease',
                          }}
                        />
                        <Box sx={{
                          position: 'absolute',
                          top: 0, right: 0, bottom: 0, left: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)',
                          p: 2.5,
                        }}>
                          <Typography sx={{
                            color: '#fff',
                            fontWeight: 800,
                            fontSize: { xs: '16px', md: '18px' },
                            textAlign: 'center',
                            textShadow: '0 2px 8px rgba(0,0,0,0.4)',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                          }}>
                            {data?.nama_makanan}
                          </Typography>
                        </Box>
                        {/* Hover chip */}
                        <Box sx={{
                          position: 'absolute',
                          top: 14, right: 14,
                          background: 'rgba(184,92,44,0.9)',
                          borderRadius: '50px',
                          px: 1.5, py: 0.5,
                          backdropFilter: 'blur(4px)',
                        }}>
                          <Typography sx={{ color: '#fff', fontSize: '11px', fontWeight: 700 }}>
                            Kuliner
                          </Typography>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                  <button
                    type="button"
                    className="see-more-link"
                    onClick={() => { window.location.href = "/makanan-khas"; }}
                  >
                    Lihat Semua Makanan Khas <ArrowForwardIcon sx={{ fontSize: 16 }} />
                  </button>
                </Box>
              </Box>
            </Slide>
          </Grid>

          {/* ===== BERITA TERBARU SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={1300}>
              <Box>
                <SectionHeader
                  title="Berita Terbaru"
                  subtitle="Informasi dan berita terkini seputar gastronomi Bandung Barat"
                />
                <Grid container spacing={3}>
                  {beritaTerbaru?.map((data, i) => (
                    <Grid item xs={12} md={4} key={i}>
                      <Card
                        className='berita'
                        onClick={() => handleCardClick(`/berita/${data?.id}`)}
                        sx={{ position: 'relative', borderRadius: '16px !important' }}
                      >
                        <img
                          src={`${BACKEND_API}${data?.image1}`}
                          alt="background"
                          style={{
                            position: 'absolute', top: 0, left: 0,
                            width: '100%', height: '100%',
                            objectFit: 'cover', zIndex: -1,
                          }}
                        />
                        <Box sx={{
                          position: 'absolute', top: 0, right: 0, bottom: 0, left: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-end',
                          background: 'linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.1) 70%, transparent 100%)',
                          p: 2,
                        }}>
                          <Typography sx={{
                            color: '#F5A623',
                            fontSize: '10px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.08em',
                            mb: 0.5,
                          }}>
                            Berita
                          </Typography>
                          <Typography sx={{
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: { xs: '14px', md: '15px' },
                            textShadow: '0 1px 4px rgba(0,0,0,0.5)',
                            lineHeight: 1.3,
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                          }}>
                            {data?.judul?.slice(0, 60)}{data?.judul?.length > 60 ? '...' : ''}
                          </Typography>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                  <button
                    type="button"
                    className="see-more-link"
                    onClick={() => { window.location.href = '/berita'; }}
                  >
                    Lihat Semua Berita <ArrowForwardIcon sx={{ fontSize: 16 }} />
                  </button>
                </Box>
              </Box>
            </Slide>
          </Grid>

          {/* ===== DUKUNGAN SECTION ===== */}
          <Grid item xs={12}>
            <Slide direction="up" in timeout={1400}>
              <Card elevation={0} sx={{
                borderRadius: '24px',
                p: { xs: 3, md: 5 },
                background: 'linear-gradient(135deg, #fff 0%, #fff8f0 100%)',
                border: '1px solid rgba(184, 92, 44, 0.10)',
                boxShadow: '0 8px 40px rgba(184, 92, 44, 0.07)',
                textAlign: 'center',
                mb: 4,
              }}>
                <SectionHeader
                  title="Didukung Oleh"
                  subtitle="Terima kasih kepada seluruh pihak yang mendukung program gastronomi Bandung Barat"
                />
                <Container maxWidth="xs" sx={{ mt: 2 }}>
                  <div className="carousel-wrapper">
                    {supportPic}
                  </div>
                </Container>
              </Card>
            </Slide>
          </Grid>

        </Grid>
      </Container>
    </div>
  );
}
